import React, { FunctionComponent, useMemo, useRef } from 'react';

import { Card, Collapse, Space } from 'antd';
import { CardProps } from 'antd/lib/card';
import classnames from 'classnames';

interface CommonCardProps extends CardProps {
  className?: string;
  loading?: boolean;
  title?: any;
  icon?: any;
  style?: React.CSSProperties;
  children?: any;
  grid?: any;
  key?: any;
  size?: any;
  color?: 'primary' | '';
  id?: string;
  noPadding?: boolean;
  enableFullscreen?: boolean;
  enableCollapse?: boolean;
}

export const CommonCard: FunctionComponent<CommonCardProps> = ({
  extra,
  title = null,
  icon = null,
  style,
  className = '',
  loading = false,
  children,
  actions,
  size = 'small',
  color = '',
  id = '',
  noPadding = false,
  enableFullscreen = false,
  enableCollapse = false,
}) => {
  if (title) {
    title = React.isValidElement(title) ? (
      title
    ) : (
      <h3>
        {icon} {`${title || ''}`}
      </h3>
    );
  }

  // const extraContent = useMemo(() => {
  //   return (
  //     <Space>
  //       {extra}
  //       {enableFullscreen && <FullScreenButton elementId={id} />}
  //       {enableCollapse && <CollapseButton elementId={id} />}
  //     </Space>
  //   );
  // }, [extra, enableFullscreen]);

  return (
    <Card
      id={id}
      loading={loading}
      size={size}
      actions={actions}
      className={classnames('CommonCard', className, color, {
        enableCollapse,
        noTitle: !title,
        noContent: !children,
        noPadding,
      })}
      style={style}
      title={title}
    //extra={extraContent}
    >
      {children}
    </Card>
  );
};

export default CommonCard;
